'use strict';

import useListeningCurationFilterValues from './useListeningCurationFilterValues.js';


function arrayValueForTracking(selectedIds, defaultValue = 'All') {
    if (_.isEmpty(selectedIds)) {
        return defaultValue;
    } else if (_.isString(selectedIds)) {
        return selectedIds;
    } else {
        return _.clone(selectedIds).sort().join(',');
    }
}

export default function useListeningSearchTracking() {

    const filters = useListeningCurationFilterValues();

    return function (searchQueryUpdates) {

        const newSearchQuery = _.extend({}, filters.listening, searchQueryUpdates);

        const trackingOptions = {
            listeningQueryId: newSearchQuery.listeningQueryId,
            primaryTerms: newSearchQuery.searchTerms,
            includeTerms: newSearchQuery.searchTermsAnd?.[0],
            narrowTerms: newSearchQuery.searchTermsAnd?.[1],
            excludeTerms: newSearchQuery.searchTermsNot,
            source: arrayValueForTracking(newSearchQuery.source),
            selectedSource: arrayValueForTracking(newSearchQuery.selectedSource),
            sentiment: arrayValueForTracking(newSearchQuery.sentiment),
            geo: arrayValueForTracking(newSearchQuery.geo),
            language: arrayValueForTracking(newSearchQuery.language),
            selectedLanguage: arrayValueForTracking(newSearchQuery.selectedLanguage),
            excludeAuthor: arrayValueForTracking(newSearchQuery.excludeAuthor, null),
            theme: arrayValueForTracking(newSearchQuery.theme, null),
            domain: arrayValueForTracking(newSearchQuery.domain, null),
            excludeDomain: arrayValueForTracking(newSearchQuery.excludeDomain, null)
        };

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ListeningSetSearchQueries, trackingOptions);

        if (!newSearchQuery.listeningQueryId) {
            RivalIQ.execute('persistence:user:save', function (userSettings) {
                userSettings.listeningLastSearch = newSearchQuery;
            });
        }
    };
}
